import { render, staticRenderFns } from "./OpenHours.vue?vue&type=template&id=47471d2c&"
import script from "./OpenHours.vue?vue&type=script&lang=js&"
export * from "./OpenHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OpenHours.vue"
export default component.exports